import { Map as MapComponent } from "@ecologi/react-components/src/Map";

export default function Map(props) {
  return <MapComponent {...props} />;
}
